<template>
  <form @submit.prevent="editOption" method="post">
    <b-row>
      <b-col cols="12" sm="12">
        <b-card>
          <div slot="header">
            <strong>{{caption}}</strong>
          </div>
          <b-row>
            <b-col sm="12">
              <div v-if="message.length > 0">
                <b-alert show dismissible variant="danger">
                  <pre>{{message}}</pre>
                </b-alert>
              </div>
              <b-form-group>
                <label for="txtNombre">Nombre</label>
                <b-form-input type="text" id="txtNombre" v-model="option.name"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="txtUrl">URL opción</label>
                <b-form-input type="text" id="txtUrl" v-model="option.url"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="rbtEstado">Estado</label>

                <b-form-radio-group id="grbtEstado" name="rbtEstado">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="rbtEstadoA"
                      name="rbtEstado"
                      class="custom-control-input"
                      value="A"
                      v-model="option.status"
                    />
                    <label class="custom-control-label" for="rbtEstadoA">Activo</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input
                      type="radio"
                      id="rbtEstadoI"
                      name="rbtEstado"
                      class="custom-control-input"
                      value="I"
                      v-model="option.status"
                    />
                    <label class="custom-control-label" for="rbtEstadoI">Inactivo</label>
                  </div>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="txtUrl">Modulo Sistema</label>
                <b-form-select v-model="option.module_id" class="mb-3">
                  <!-- This slot appears above the options from 'options' prop -->
                  <template slot="first">
                    <option :value="null" disabled>-- Por favor seleccione una opción --</option>
                  </template>

                  <option v-for="item in lstModule" :key="item.id" :value="item.id">{{ item.name }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button @click="goBack" variant="primary" class="mr-1">Cancelar</b-button>

          <b-button type="submit" variant="success">Guardar</b-button>
        </b-card>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  name: "optionEdit",
  props: {
    caption: {
      type: String,
      default: "Opción Sistema"
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      lstModule: [],
      option: {},
      datos: [],
      message: ""
    };
  },
  mounted() {
    this.$http.get(`${this.$urlApi}parameters/1?token=${this.token}`).then(
      response => {
        this.lstModule = response.data.data;
      },
      error => {
        console.log(error);
        alert(error.body.message);
      }
    );

    let id = this.$route.params.id;

    this.$http.get(`${this.$urlApi}options/${id}?token=${this.token}`).then(
      response => {
        this.option = response.data.data;
      },
      error => {
        console.log(error);
        alert(error.body.message);
      }
    );
  },
  computed: {},
  methods: {
    editOption() {
      showLoader();
      let id = this.option.id;
      this.datos = JSON.stringify(this.option);

      this.$http
        .put(`${this.$urlApi}options/${id}?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" }
        })
        .then(function(response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar"
          }).then(result => {
            if (result.value) {
              location.href = `${location.origin}/#/options`;
            }
          });
        })
        .catch(error => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
